import { render, staticRenderFns } from "./ManageFilingClassificationPlan.vue?vue&type=template&id=044fc650&scoped=true"
import script from "./ManageFilingClassificationPlan.vue?vue&type=script&lang=js"
export * from "./ManageFilingClassificationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fc650",
  null
  
)

export default component.exports